<template>
  <div>
    <div class="docs-container">
      <div class="docs-box">
        <el-carousel :interval="0"
                     height="500px">
          <el-carousel-item>
            <div class="docs">
              <div class="title fade-in">文档简介</div>
              <div class="content ">我们为自己设定的任务是创建一个文档，让您可以再其中找到符合您需求的SDK接口，生成漂亮的交互式气象可视化地图，并了解相关参数的更多信息。</div>
              <br>
              <div class="content ">有时您可能没有时间去寻找符合条件的地图示例。为了促进这一过程，我们研究了这组工具并希望与您分享。</div>
              <br>
              <div class="content ">我们的文档刚刚发布，目前处于测试阶段，如果您想了解最新信息，或者有任何问题，甚至是建议，请随时与我们联系！</div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="docs">
              <div class="title fade-in">示例</div>
              <div class="content ">如果您希望在页面上获取第一份交互式气象可视化地图</div>
              <br>
              <div class="content ">请在标题栏点击并前往 示例 页面</div>
              <div class="content ">
                <div class="linkTo"
                     @click="goPage('example')">示例 将帮助产品开发人员搭建逻辑清晰、结构合理且高效易用的产品。</div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="docs">
              <div class="title fade-in">API</div>
              <div class="content">
                <div class="linkTo"
                     @click="goPage('api')">使用 API 文档快速查询气象要素常量等参数。</div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="docs">
              <div class="title fade-in ">还有问题?</div>
              <div class="content ">如果您还有其他问题请联系技术开发人员。</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  methods: {
    goPage(key) {
      this.$router.push({ path: "/sdk/" + key });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
::v-deep .el-carousel {
  top: 15%;
}
.docs-container {
  height: 100%;
  text-align: left;
  // background-color: #f0f0f0;
  background-image: linear-gradient(270deg, #757f9a, #d7dde8);
  display: flex;
  .docs-box {
    width: 1000px;
    overflow: hidden;
    // padding: 100px 0;
    margin: 30px auto;
    background-color: #fff;
    box-shadow: 0px 8px 8px 0px rgb(0 0 0 / 25%);
    border-radius: 18px;
  }
}
.docs {
  padding: 0 100px;
}
::v-deep .el-carousel__button {
  background-color: #3a8ee6 !important;
}
.title {
  padding-top: 40px;
  padding-bottom: 30px;
  font-size: 2.5rem;
  font-weight: 700;
}
.fade-in {
  -webkit-animation: tracking-in-contract 0.8s
    cubic-bezier(0.215, 0.61, 0.355, 1) both;
  animation: tracking-in-contract 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) both;
}

@-webkit-keyframes tracking-in-contract {
  0% {
    letter-spacing: 1em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    letter-spacing: normal;
    opacity: 1;
  }
}
@keyframes tracking-in-contract {
  0% {
    letter-spacing: 1em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    letter-spacing: normal;
    opacity: 1;
  }
}
.content {
  padding-top: 0;
  padding-bottom: 1rem;
  font-size: 1.3rem;
  text-align: left;
  .linkTo {
    cursor: pointer;
    background: linear-gradient(90deg, #a578c7, #9d76bb);
    background-size: 0 100px;
    background-repeat: no-repeat;
    background-position: 0 100%;
    background-clip: text;
    transition: 0.6s all linear;
  }
}
.content:hover .linkTo {
  background-size: 100% 100%;
  color: transparent;
}
</style>